

export default {
  props: {
    items: {
      type: Array,
      required: true
    },

    loop: {
      type: Boolean
    },

    snap: {
      type: Boolean
    },

    itemWidth: {
      type: Number,
      default: 400
    },

    autoscroll: {
      type: Boolean
    },

    disableCurtain: {
      type: Boolean
    }
  },

  data () {
    return {
      internalItemWidth: this.itemWidth,
      isDragging: false,
      dragStart: 0,
      scrollStart: 0,

      current: 0,
      target: 0
    };
  },

  computed: {
    carrouselWidth () {
      return this.items.length * this.internalItemWidth;
    },
    currentIndex () {
      return Math.round(Math.abs(this.current) / this.internalItemWidth);
    }
  },

  mounted () {
    window.addEventListener('mousemove', e => this.onMouseMove(e));
    window.addEventListener('mouseup', e => this.onMouseUp(e));
    window.addEventListener('touchmove', e => this.onTouchMove(e));
    window.addEventListener('touchend', e => this.onMouseUp(e));

    window.addEventListener('resize', () => {
      if (window.innerWidth < 500) {
        this.internalItemWidth = window.innerWidth - 48;
      } else {
        this.internalItemWidth = this.itemWidth;
      }
    });

    if (window.innerWidth < 500) {
      this.internalItemWidth = window.innerWidth - 48;
    }

    this.move();

    if (this.autoscroll) {
      setInterval(() => this.advanceView(), 2500);
    }
  },

  methods: {
    scrollIntoView (index) {
      this.setTarget(0 - index * this.internalItemWidth);
    },
    next () {
      const targetIndex = this.currentIndex + 1;

      if (targetIndex >= this.items.length) {
        if (this.loop) {
          this.setTarget(0);
        } else {
          this.setTarget(this.current);
        }
      } else {
        this.setTarget(0 - targetIndex * this.internalItemWidth);
      }
    },

    prev () {
      const target = this.currentIndex - 1;

      if (target < 0) {
        if (this.loop) {
          this.setTarget(0 - (this.items.length - 1) * this.internalItemWidth);
        } else {
          this.setTarget(this.current);
        }
      } else {
        this.setTarget(0 - target * this.internalItemWidth);
      }
    },

    // TODO: fix autoscroll
    advanceView () {
      const viewWidth = (Math.floor(window.innerWidth / this.internalItemWidth) * this.internalItemWidth) / 2 + this.internalItemWidth / 2;
      if (this.target <= -this.carrouselWidth + viewWidth) {
        this.setTarget(0);
      } else {
        this.setTarget(this.target - this.internalItemWidth);
      }
    },

    setTarget (target) {
      const viewWidth = (Math.floor(window.innerWidth / this.internalItemWidth) * this.internalItemWidth) / 2 + this.internalItemWidth;
      this.target = Math.min(Math.max(target, -this.carrouselWidth + viewWidth), 0);
    },

    onMouseDown (e) {
      this.dragStart = e.clientX;
      this.scrollStart = this.current;
      this.isDragging = true;
      e.preventDefault();
    },

    onTouchStart (e) {
      this.dragStart = e.changedTouches[0].clientX;
      this.scrollStart = this.current;
      this.isDragging = true;
      e.preventDefault();
    },

    onMouseUp (e) {
      this.dragStart = 0;
      this.isDragging = false;
      e.preventDefault();

      if (this.snap) {
        this.setTarget(Math.round(this.current / this.internalItemWidth) * this.internalItemWidth);
      } else {
        this.current = this.target;
      }
    },

    onMouseMove (e) {
      if (this.isDragging) {
        e.preventDefault();
        this.setTarget(this.scrollStart + e.clientX - this.dragStart);
      }
    },

    onTouchMove (e) {
      if (this.isDragging) {
        e.preventDefault();
        this.setTarget(this.scrollStart + e.changedTouches[0].clientX - this.dragStart);
      }
    },

    move () {
      const damping = 0.32;
      if (Math.abs(this.current - this.target) < 0.1) {
        this.current = this.target;
        requestAnimationFrame(() => this.move());
        return;
      }

      this.current = (1 - damping) * this.current + damping * this.target;

      this.$el.children[0].style.transform = `translate(${this.current}px)`;

      requestAnimationFrame(() => this.move());
    }
  }
};
